import { observer } from 'mobx-react-lite';
import React, { useMemo, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
//import { useStore } from "../../stores/store";
//import { userLanguage } from "../userLanguageSchema/userLanguage";

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '50px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  // width: "890px",
  transition: 'border .24s ease-in-out',
};

const activeStyle = {
  borderColor: '#2196f3',
};

const acceptStyle = {
  borderColor: '#00e676',
};

const rejectStyle = {
  borderColor: '#ff1744',
};

const thumbsContainer: any = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16,
};

const img = {
  display: 'flex',
  width: '10%',
  height: '10%',
};

interface IImageUpload {
  files: File[];
  onDrop: (acceptedFiles: File[]) => void;
  name:string
}

const AssetDragDrop: React.FC<IImageUpload> = ({ files, onDrop,name }) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: (name === 'Av Sync Upload') ? '.xls, .xlsx, .ods' : '.pdf, image/*, audio/*, video/*',
    onDrop: onDrop,
  });
  const style: any = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragAccept, isDragReject],
  );

  //const { commonStore } = useStore();
  const thumbs = files.map((file: any) => (
    <div key={file.id}>
      <div>
        <img
          src={
            file.type.includes('image') ? file.preview : '/assets/documents.jpg'
          }
          alt=""
          style={img}
          height="70px"
        />
        <p style={{ color: 'black' }}>{file.name}</p>
      </div>
    </div>
  ));
  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file: any) => URL.revokeObjectURL(file.preview));
    },
    [files],
  );

  return (
    <div style={{ width: '100%' }}>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <p //Drag and drop some files here, or click to select files
        //{(userLanguage[0].Level3InventoryRecievingVerify?.IRVFDL01 as any)?.[`${commonStore.language.key}`]}
        >
          Drag and drop some files here, or click to select files
        </p>
      </div>
      <aside style={thumbsContainer}>{thumbs}</aside>
    </div>
  );
};

export default observer(AssetDragDrop);
